import { RepeatableTwoInputswithImage } from "@/components";
import React from "react";

const ServiceFeaturesFieldSection = ({
  control,
  errors,
  formData,
  filesList,
  allFiles,
  paginationDetails,
  handleAddRepeatableField,
  handleOnChangeRepeatableFields,
  handleRemoveRepeatableField,
  adminRole,
  permissionsList,
  searchValue,
  selectedFileType,
  isItemDetailsExist = false,
  isHideInOtherLanguages = false,
}) => {
  return (
    <>
      {/* Service Features */}
      <RepeatableTwoInputswithImage
        formData={formData}
        labelText="Features"
        fieldId={
          isItemDetailsExist ? "service-update-features" : "service-features"
        }
        translateField={isItemDetailsExist}
        repeatableKeyname="service_features"
        repeatableKeys={["icons", "titles"]}
        addNewField={handleAddRepeatableField}
        removeField={handleRemoveRepeatableField}
        onChangeField={handleOnChangeRepeatableFields}
        filesList={filesList}
        allFiles={allFiles}
        paginationDetails={paginationDetails}
        searchValue={searchValue}
        selectedFileType={selectedFileType}
        adminRole={adminRole}
        permissionsList={permissionsList}
        isDetailsExist={isItemDetailsExist}
        isHideInOtherLanguages={isHideInOtherLanguages}
        inputBoxMaxWidth="xl:max-w-[500px]"
      />
    </>
  );
};

export default ServiceFeaturesFieldSection;
